import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./i18n/config";
import { syncDocumentLanguage } from "./i18n/config";
import { createRouter } from "./router";
import "./styles/global.css";

syncDocumentLanguage(document.documentElement.lang || "en");

const router = createRouter();

const rootEl = document.getElementById("root");
if (!rootEl) {
	throw new Error("Root element #root not found in document.");
}

createRoot(rootEl).render(
	<StrictMode>
		<RouterProvider router={router} />
	</StrictMode>,
);
